import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from '../../../context/translationProvider'
import { If } from '../../atoms/if'
import { 
  TourStepContainer, 
  TourStepHeader, 
  TourStepTitle, 
  TourStepContent, 
  TourStepProgress, 
  TourStepFooter, 
  TourStepButton,
  TourStepButtonContainer,
  TourStepCloseButton 
} from './styles'

const TourStep = ({
  steps,
  currentStep,
  setCurrentStep,
  setIsOpen,
  ...stepProps
}) => {
  const { translate } = useTranslation()
  const totalSteps = steps?.length || 0
  const currentStepIndex = currentStep + 1
  const isMultipleSteps = totalSteps > 1
  const isFirstStep = currentStep === 0
  const isLastStep = currentStep === totalSteps - 1
  
  const currentStepData = steps?.[currentStep] || {}
  const { content: stepContent, hideBackButton } = currentStepData

  const handlePrevious = () => {
    if (!isFirstStep) {
      setCurrentStep(currentStep - 1)
    }
  }

  const handleNext = () => {
    if (isLastStep) {
      setIsOpen(false)
    } else {
      setCurrentStep(currentStep + 1)
    }
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const renderContent = () => {
    if (typeof stepContent === 'function') {
      return stepContent({ 
        steps, 
        currentStep, 
        setCurrentStep, 
        setIsOpen,
        ...stepProps 
      })
    }
    return stepContent
  }

  return (
    <TourStepContainer>
      <TourStepHeader>
        <TourStepTitle>
          {currentStepData?.title}
        </TourStepTitle>
        <TourStepCloseButton 
          onClick={handleClose}
          aria-label="Close tour"
        />
      </TourStepHeader>
      
      <TourStepContent>
        {renderContent() || currentStepData?.content}
      </TourStepContent>
      
      <If 
        condition={isMultipleSteps}
        render={() => (
          <TourStepFooter>
            <TourStepProgress>
              {translate('game.onboardingTutorial.stepIndicator', '{current} of {total}')
                ?.replace('{current}', currentStepIndex)
                ?.replace('{total}', totalSteps)}
            </TourStepProgress>
            
            <TourStepButtonContainer>
              <If
                condition={!hideBackButton}
                render={() => (
                  <TourStepButton 
                    $direction="left"
                    disabled={isFirstStep}
                    onClick={handlePrevious}
                    aria-label="Previous step"
                  />
                )}
              />
              
              <TourStepButton 
                $direction="right"
                onClick={handleNext}
                aria-label={isLastStep ? 'Finish tour' : 'Next step'}
              />
            </TourStepButtonContainer>
          </TourStepFooter>
        )}
      />
    </TourStepContainer>
  )
}

TourStep.propTypes = {
  steps: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  setIsOpen: PropTypes.func.isRequired,
}

export { TourStep } 